var v1="<div class=\"header\"> <div ng-show=\"$root.showSideMenu\" ng-click=\"openNav()\" ng-class=\"{'hamburger': !arrow, 'arrow-left': arrow}\" class=\"nav-toggle\"> <p ng-show=\"!arrow\"></p> <p ng-show=\"arrow\"></p> <div class=\"header-hamburger\"> <span></span> </div> </div> <div style=\"text-align:right; color: white; margin-top:-25px; margin-right:30px; font-size:22px\">School Name Here</div> </div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("header.htm", v1)}]);
module.exports=v1;


/*****************
 ** WEBPACK FOOTER
 ** ./src/olr-mainfe/header.htm
 ** module id = 263
 ** module chunks = 1
 **/